import {useState} from "react"
import "./v2/styles/_white-paper-popup-subscribe.module.scss";
import "./v2/styles/_form-with-btn.module.scss";

let isValidInputs = true
const SubscribeBlock = (props) => {
    const [email, setEmail] = useState("");
    const [emailErr, setEmailErr] = useState(false);
    const [emailErrText, setEmailErrText] = useState('Invalid Email!');
    const [subscribeSuccess, setSubscribeSuccess] = useState(false);
    const handleSubmit = (e) => {
        e.preventDefault()
        validateInputs()

            if(isValidInputs){
                var xhr = new XMLHttpRequest();
                var url = "https://api.hsforms.com/submissions/v3/integration/submit/25310090/1d995a7c-cbe1-49aa-ae7c-0a94659c24ab";
                var data = {
                    submittedAt: Date.now(),
                    fields: [
                        {
                            name: "email",
                            value: email,
                        }

                    ],
                    "context": {
                        "pageUri": props.pageUrl,
                        "pageName": props.pageTitle || ''

                    },
                };
                var final_data = JSON.stringify(data);
                xhr.open("POST", url);
                xhr.setRequestHeader("Content-Type", "application/json");
                setSubscribeSuccess(true)
                setEmail('')

                xhr.onreadystatechange = function () {
                    if (xhr.readyState == 4 && xhr.status == 200) {
                        setTimeout(()=>{
                            setSubscribeSuccess(false)
                        },3000)
                        // Returns a 200 response if the submission is successful.
                    } else if (xhr.readyState == 4 && xhr.status == 400) {
                        setEmailErrText(xhr.responseText)
                    } else if (xhr.readyState == 4 && xhr.status == 403) {
                        setEmailErrText(xhr.responseText)
                    }
                };
                const runConditionAfterTwoMinutes = () => {
                    xhr.send(final_data);
                }
                setTimeout(runConditionAfterTwoMinutes, 120000);
            }


    }
    const handleChange = (e) => {
        const value = e.target && e.target.value
        setEmail(value)
    }
    const validateInputs = () => {
        const emailRegEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        let emailId = email
        let isInvalidEmail = emailId.length < 2 || !emailRegEx.test(String(emailId).toLowerCase())
        if(isInvalidEmail){
            setEmailErr(true)
        }
        isValidInputs = !isInvalidEmail
    }
    const handleKeyUp = (e)=>{
        let emailId = email
        if(emailId.length > 0){
            setEmailErr(false)
        }
    }

    return <>
        {props.isWhitepaper ? <div className={"whitepaper-popup-subscribe"}>
            <h2>Subscribe to get our best content in your inbox</h2>
            <form method={'post'} onSubmit={(e) => handleSubmit(e)}>
                <input type={"text"} value={email}
                       className={`${emailErr ? 'is-error subscribe-input' : 'subscribe-input'}`} onChange={(e) => {
                    handleChange(e)
                }}
                       onKeyUp={(e) => {
                           handleKeyUp(e)
                       }} placeholder={"Enter your email to start"}/>
                <button className={"ahref-btn primary"}>Subscribe</button>
                <h6 style={{
                    color: `${subscribeSuccess ? 'green' : 'red'}`,
                    display: `${emailErr || subscribeSuccess ? "block" : "none"}`
                }}>{subscribeSuccess ? 'Thank you for subscribing! ' : emailErrText}</h6>
            </form>
        </div> : <div className={"form-with-btn"}>
            <form method={'post'} onSubmit={(e) => handleSubmit(e)}>
                <input type={"text"} value={email}
                       className={`${emailErr ? 'is-error subscribe-input' : 'subscribe-input'}`} onChange={(e) => {
                    handleChange(e)
                }}
                       onKeyUp={(e) => {
                           handleKeyUp(e)
                       }} placeholder={"Enter your email"}/>
                <button className={"ahref-btn primary"}>Subscribe</button>
            </form>
            <h6 style={{
                    color: `${subscribeSuccess ? 'green' : 'red'}`,
                    display: `${emailErr || subscribeSuccess ? "block" : "none"}`
                }}>{subscribeSuccess ? 'Thank you for subscribing! ' : emailErrText}</h6>
        </div>}


    </>
}


export default SubscribeBlock;